import { api, type Page } from "@/lib/api/client";
import type {
  CreateProductRequestInput,
  ProductRequest,
  ProductRequestListFilters,
  RegulatorySectionInput,
  WarehouseSectionInput,
} from "./product-requests.types";

const BASE = "/marketing/product-requests";

/**
 * Yeni ürün talepleri — pz-akis 6 Ekim 2026 (plan M12).
 *
 * BÖLÜM YAZMAK VE ADIMI İLERLETMEK İKİ ÇAĞRI. Önce bölüm (`PATCH …/regulatory|warehouse`),
 * sonra görev (`POST /workflow/tasks/:id/approve`). Tek bir uç olsaydı «kaydet» ile «onayla»
 * aynı yetkinin iki yüzü olurdu; ayrı kalınca onay motoru kendi kuralını (görevler ayrılığı,
 * vekalet) bozulmadan uyguluyor.
 */
export const productRequestsApi = {
  list(filters: ProductRequestListFilters): Promise<Page<ProductRequest>> {
    return api.page<ProductRequest>(BASE, { params: { ...filters } });
  },
  get(id: string): Promise<ProductRequest> {
    return api.get<ProductRequest>(`${BASE}/${id}`);
  },
  /** Açar ve onaya gönderir; yeniden denemesi güvenli değil, anahtar gövdeye bağlı. */
  create(input: CreateProductRequestInput, idempotencyKey: string): Promise<ProductRequest> {
    return api.post<ProductRequest>(BASE, input, { idempotencyKey });
  },
  updateRegulatory(id: string, input: RegulatorySectionInput): Promise<ProductRequest> {
    return api.patch<ProductRequest>(`${BASE}/${id}/regulatory`, input);
  },
  updateWarehouse(id: string, input: WarehouseSectionInput): Promise<ProductRequest> {
    return api.patch<ProductRequest>(`${BASE}/${id}/warehouse`, input);
  },
  /** Çağıranın açık görevini onaylar — bölümü yazan kişinin «onaya gönder» adımı. */
  approveTask(taskId: string, comment?: string): Promise<unknown> {
    return api.post(`/workflow/tasks/${taskId}/approve`, comment ? { comment } : {});
  },
  /** Ret gerekçe ister (en az 5 karakter): talep eden çıplak bir «hayır»la bir şey yapamaz. */
  rejectTask(taskId: string, comment: string): Promise<unknown> {
    return api.post(`/workflow/tasks/${taskId}/reject`, { comment });
  },
};
